export default "__VITE_ASSET__VHAlhm2W__"